import { render, staticRenderFns } from "./teacher_details.vue?vue&type=template&id=339d63b6&scoped=true"
import script from "./teacher_details.vue?vue&type=script&lang=js"
export * from "./teacher_details.vue?vue&type=script&lang=js"
import style0 from "./teacher_details.css?vue&type=style&index=0&id=339d63b6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339d63b6",
  null
  
)

export default component.exports